import sectionReviewInfiniteMarqueeCss from '../css-snippets/section-review-infinite-marquee';
const html = `
<style>${sectionReviewInfiniteMarqueeCss}</style>
<div
  class="review-infinite-marquee-container-wrapper review-infinite-marquee-container-wrapper-unique-id"
  data-top-padding="true"
  data-bottom-padding="true"
  data-enable-rating="true"
  data-image-size="large"
  data-container-style="false"
>
  <div class="review-infinite-marquee-container">
    <div class="review-infinite-marquee-header" data-show="true">
      <div
        data-attribute="review-infinite-marquee-title"
        class="review-infinite-marquee-title"
      >
        <h2 style="text-align: center">
          <strong>Real Results from Real People</strong>
        </h2>
      </div>
      <div class="review-infinite-marquee-rating">
        <div
          data-attribute="review-infinite-marquee-rating-stars"
          data-full-stars="5"
          class="review-infinite-marquee-wrap-stars"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="0"
            height="0"
            style="position: absolute"
          >
            <defs>
              <linearGradient
                id="half-star-gradient-infinite"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="0%"
              >
                <stop
                  offset="50%"
                  style="stop-color: #f0b100; stop-opacity: 1"
                />
                <stop
                  offset="50%"
                  style="stop-color: #f0b100; stop-opacity: 0"
                />
              </linearGradient>
            </defs>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
            ></path>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
            ></path>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
            ></path>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
            ></path>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"
            ></path>
          </svg>
        </div>
        <div class="review-infinite-marquee-rating-value">
          <span data-attribute="review-infinite-marquee-rating-value">5</span>/5
        </div>
      </div>
      <div
        data-attribute="review-infinite-marquee-description"
        class="review-infinite-marquee-description"
      >
        4,700+ Happy Customers
      </div>
    </div>
    <div class="review-infinite-marquee-wrapper-list">
      <div
        data-attribute="review-infinite-marquee-list"
        class="review-infinite-marquee-list"
      >
        <div
          data-attribute="review-infinite-marquee-item"
          class="review-infinite-marquee-item"
        >
          <img
            loading="lazy"
            data-attribute="review-infinite-marquee-item-avatar"
            src="https://cdn.skyfastimg.com/images/2025/09/13/image-68c52804c0c972d768e64960.gif?w=50&h=50&q=80"
            alt=""
          />
        </div>
        <div
          data-attribute="review-infinite-marquee-item"
          class="review-infinite-marquee-item"
        >
          <img
            loading="lazy"
            data-attribute="review-infinite-marquee-item-avatar"
            src="https://cdn.skyfastimg.com/images/2025/09/13/image-68c528d52f6b529d35fdbf2e.gif?w=50&h=50&q=80"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="review-infinite-marquee-tag" data-attribute="review-infinite-marquee-tag" data-show="false">
      173,000+ Happy Women
    </div>
  </div>
</div>
`;
export default html;
